import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import { ProductGroupInput } from '@occc/graphql';

import { ProductGroupFormContent } from './ProductGroupFormContent';

import { ProductGroupFormRenderCallback, ProductGroupFormValues } from '../types';
import { validate } from '../validation';

export interface IProductGroupConfigurationFormProps {
  id?: string;
  readOnly: boolean;
  initialValues: ProductGroupInput;
  onSubmit: (values: ProductGroupInput) => void;
  children?: ProductGroupFormRenderCallback;
  title: string;
}

export const ProductGroupForm: React.FC<IProductGroupConfigurationFormProps> = ({
  title,
  children,
  readOnly,
  initialValues,
  id,
  onSubmit,
}) => {
  const renderForm = React.useCallback(
    ({ handleSubmit, values }: FormRenderProps<ProductGroupFormValues>) => (
      <form id={id} onSubmit={handleSubmit}>
        <ProductGroupFormContent readOnly={readOnly} values={values} title={title} />
        {children ? children(values) : null}
      </form>
    ),
    [id, readOnly, children, title],
  );

  return (
    <Form<ProductGroupFormValues>
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={renderForm}
      validate={validate}
    />
  );
};
